import { clusterApiUrl } from "@solana/web3.js";
// Use this instead of the solana public RPC endpoint which is less reliable.
const DEFAULT_PROD_RPC = "https://solana-mainnet.rpc.extrnode.com/";
export const defaultRPC = (cluster) => {
    switch (cluster) {
        case "mainnet-beta":
            return DEFAULT_PROD_RPC;
        default:
            return clusterApiUrl(cluster);
    }
};
